import { render, staticRenderFns } from "./VeiculosTab.vue?vue&type=template&id=ce0210f8"
import script from "./VeiculosTab.vue?vue&type=script&lang=js"
export * from "./VeiculosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports